module.exports = __webpack_public_path__ + "img/sidenav-item-sale-record.2df390fa.svg";